import { Container } from "inversify";
import "reflect-metadata";
import { AuthService } from "@/services/auth.service";
import { FileSharingService } from "@/services/file-sharing.service";

const container = new Container();

container.bind("authService").to(AuthService).inSingletonScope();
container.bind("fileSharingService").to(FileSharingService).inSingletonScope();

export { container };
